const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    firstname: {
      type: 'string',
      title: 'نام',
      default: '',
    },
    lastname: {
      type: 'string',
      title: 'نام خانوادگی',
      default: '',
    },
    national_code: {
      type: 'string',
      title: 'کد ملی',
      minLength: 10,
      maxLength: 10,
      pattern: '^[0-9]{10}$',
    },
    birth_date: {
      type: 'string',
      title: 'تاریخ تولد',
      format: 'date',
    },
    gender: {
      type: 'number',
      title: 'جنسیت',
      oneOf: [
        { const: 1, title: 'مرد' },
        { const: 0, title: 'زن' },
      ],
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
    email: {
      type: 'string',
      title: 'ایمیل',
      format: 'email',
    },
  },
});

export default schema;
